const STATUS_COLOR_MAP = {
    pendiente_comprobante: { label: 'Pendiente comprobante', color: '#f1b44c' },
    pendiente_pago:        { label: 'Pendiente de pago',     color: '#50a5f1' },
    pagada:                { label: 'Pagada',                color: '#34c38f' },
    cancelada:             { label: 'Cancelada',             color: '#74788d' },
}

const TIPO_COMPROBANTE_MAP = {
    I: { label: 'Factura de Ingreso',       badgeLabel: null },
    E: { label: 'Nota de Crédito',          badgeLabel: 'Nota de Crédito' },
    P: { label: 'Complemento de Pago',      badgeLabel: 'Complemento de Pago' },
    N: { label: 'Nómina',                   badgeLabel: 'Nómina' },
}

export const getStatusBadge = (status) => {
    return STATUS_COLOR_MAP[status] || { label: status || 'Desconocido', color: '#74788d' }
}

export const getTipoComprobanteInfo = (tipo) => {
    return TIPO_COMPROBANTE_MAP[tipo] || { label: `Tipo ${tipo || '?'}`, badgeLabel: null }
}

export const buildEgresoEmisor = (egreso = {}) => ({
    rfc:           egreso.emisor?.rfc           || null,
    nombre:        egreso.emisor?.nombre        || null,
    regimenFiscal: egreso.emisor?.regimenFiscal || null,
})

export const buildEgresoReceptor = (egreso = {}) => ({
    rfc:    egreso.receptor?.rfc    || null,
    nombre: egreso.receptor?.nombre || null,
})

export const buildEgresoTotales = (egreso = {}) => ({
    subtotal:          egreso.subtotal                        || 0,
    descuento:         egreso.descuento                       || null,
    totalTrasladados:  egreso.impuestos?.totalTrasladados     || null,
    totalRetenidos:    egreso.impuestos?.totalRetenidos       || null,
    total:             egreso.total                           || 0,
    moneda:            egreso.moneda                          || 'MXN',
    tipoCambio:        egreso.tipoCambio                      || 1,
})

export const buildEgresoTimbre = (egreso = {}) => {
    if (!egreso.tieneComprobante || !egreso.uuid) return null
    return {
        uuid:           egreso.uuid,
        fechaTimbrado:  egreso.fechaTimbrado || null,
    }
}
